// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"0f194269","199":"4d0df5e4","651":"0f194269"}[chunkId] + ".chunk.css";
};